<template>
    <section id="Signup">
        <b-modal @hide="onHide" id="signup-modal" ref="regModalRef" hide-header hide-footer centered>
            <div class="sign-up mx-auto d-flex justify-content-center align-items-center position-relative">
                <button
                    @click="$store.commit('TOGGLE_MODAL', ['sign-up', false])"
                    aria-label="Close"
                    class="close pr-2"
                    id="modal-close">
                        <CloseCross/>
                </button>
                <div class="modal-container-wrap">
                    <div class="text-center">
                        <p class="p3b c22">Sign Up</p>
                        <p v-if="message" id="err-message" class="c5 p1n">{{message}}</p>
                        <p v-else class="c23 p1n">New to CrossProm?</p>
                    </div>
                    <GoogleLogin
                        :authType = "{term: 'sign-up', name: 'Sign Up', btnText: 'Sign up'}" />
                    <div class="text-center mt-4 pt-4 border-top">
                        <p class="c23 p1n">Or create an account! It won't take long. </p>
                    </div>
                    <div>
                        <md-field id="name-field" :class="{'name-required': !validName}">
                            <label class="p1n px-2">Enter your name</label>
                            <md-input id="name-input" class="p1n" v-model="name"></md-input>
                            <div class="name-required" v-if="!validName">
                                <span 
                                    class="c5o7 lab">
                                        Name field is required
                                </span>
                            </div>
                        </md-field>
                        <EmailInput 
                            :activ-fields="{email: true, password: true}"
                            :on-email-confirmed="onEmailConfirmed"
                            :on-pass-confirmed="onPassConfirmed"
                            :on-submit="SignUp"
                            @passwordDone="passwordDone = $event"
                            @emailDone="emailDone = $event"
                            />
                        <button 
                            id="signup-button"
                            :class="{'inactive': !email || !name || !password}"
                            @click="SignUp" 
                            class="c16 p2b phiolet_button mt-3">
                                Sign Up 
                        </button>
                    </div>
                    <div>
                        <p v-if="!isEcommercePlatform" class="c23 p1n my-4">
                            By clicking Sign Up you accept 
                            <router-link id="terms-link" class="c1 underlined_links" to="/termsofuse">
                                Terms and Conditions
                            </router-link>
                        </p>
                        <div class="d-flex justify-content-center" :class="{'my-4': isEcommercePlatform}">
                            <p 
                                @click="$store.commit('CLOSE_MODALS'); $store.dispatch('clearErrors'); $store.commit('TOGGLE_MODAL', ['login', {
                                    openedFrom: 'Signup Modal'
                                }])"
                                id="login-modal-link"
                                class="c1 p1n text-center underlined_links">
                                    Already have an account?
                            </p>
                        </div>
                    </div>
                    
                </div>
            </div>
        </b-modal>
    </section>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
import {CloseCross} from '../components/Icons'
import { PROFILE_PIC_PLACEHOLDER} from "../constants"
import GoogleLogin from '../components/GoogleLogin'
import { referralUseCase } from '../core/usecases'
import {
    db,
    auth
} from '../firebase.js'
import EmailInput from '@/components/EmailPasswordValid/EmailInput.vue'

export default {
    name: 'SignUp',
    components: {
        EmailInput,
        CloseCross,
        GoogleLogin
    },
    data: function () {
        return {
            name: null,
            email: null,
            password: null,
            validName: true,
            passowrdDone: false,
            emailDone: false,
        }
    },
    computed: {
        ...mapState([
            'user',
            'message',
            'modals',
            'platform'
        ]),
        ...mapGetters([
            'isEcommercePlatform',
            'usersCollection'
        ])
    },
    mounted: function() {
        this.$bvModal.show(`signup-modal`)
        this.$ga.event('Auth', 'Sign Up Modal Opened', 'OpenedFrom', this.modals['sign-up'].openedFrom);
        this.$sendMixpanelEvent('Sign Up Modal Opened', {
            'Opened From': this.modals['sign-up'].openedFrom
        });
    },
    methods: {
        onHide: function(evt) {
            this.name = null;
            this.email = null;
            this.password = null;
            this.validName = true
            this.$store.dispatch('clearErrors');
            setTimeout(() => {
                this.$store.commit('TOGGLE_MODAL', ['sign-up', false])
            }, 0)
        },
        SignUp: function () {
            if (this.email && this.email.length && this.password && this.password.length && this.passwordDone && this.emailDone) {
                if (!this.name) {
                    this.validName = false
                    return 
                }
                this.validName = true
                const chosenPlanOnSignup = this.modals['sign-up'] && this.modals['sign-up'].chosenPlanOnSignup || {
                    chosenPlanOnSignup: 'basic'
                }

                auth
                    .createUserWithEmailAndPassword(this.email, this.password)
                    .then(async data => {
                        const name = this.name

                        data.user
                            .updateProfile({
                                displayName: name,
                                platform: this.platform
                            })
                            .catch(console.log)

                        let eventProps = `
                            AuthType: Email/Password,
                            Email: ${data.user.email},
                            Date: ${new Date().toISOString()},
                        `;

                        if(!this.isEcommercePlatform) {
                            eventProps+= `SignupType: ${chosenPlanOnSignup.name === 'premium' ? 'Premium' : 'Basic'}`
                        }

                        const userData = {
                            name: name,
                            email: data.user.email,
                            userId: data.user.uid,
                            user_img: data.user.photoURL && data.user.photoURL.length ?
                                data.user.photoURL :
                                PROFILE_PIC_PLACEHOLDER,
                            verified: false,
                            platform: this.platform,
                            authProvider: 'email/pass'
                        }

                        this.$store.dispatch('auth')
                        this.$store.commit('TOGGLE_MODAL', ['sign-up', false])
                        this.$store.commit('TOGGLE_MODAL', ['confirm-reg', true])

                        if(this.platform !== 'ecommerce') {
                            data.user
                            .sendEmailVerification()
                            .catch(e => this.$store.dispatch('handleErrors', e))
                        }

                        if(!this.isEcommercePlatform) {
                            userData.chosenPlanOnSignup = chosenPlanOnSignup
                        }

                        await db.collection(this.usersCollection)
                            .doc(data.user.uid)
                            .set(userData)
                        
                        if(this.$route.query.refId) {
                            this.$sendMixpanelEvent('Signup With Referral Link', {
                                RefId: this.$route.query.refId,
                                UserEmail: data.user.email
                            })
                            this.$ga.event('Referral', 'Signup With Referral Link', `
                                RefId: ${this.$route.query.refId},
                                UserEmail: ${data.user.email}
                            `)
                            referralUseCase.updateMyReferral(`referral-${this.$route.query.refId}`, data.user.uid, data.user.email)
                        }
                        else {
                            referralUseCase.updateMyReferral('', data.user.uid, data.user.email)
                        }

                        this.$ga.event('Auth', 'Sign Up', eventProps)
                        this.$sendMixpanelEvent('Sign Up');
                    })
                    .catch(e => {
                        if(e.code === 'auth/email-already-in-use') {
                            e.message = "The email is already registered"
                            this.$store.dispatch('handleErrors', e)
                        }  
                    })
                        
            }
        },
        onEmailConfirmed(val) {
            this.email = val;
        },
        onPassConfirmed(val) {
            this.password = val;
        }
    },
    
}
</script>

<style scoped lang="scss">
div.sign-up {
    width: 450px;
    background: #FFFFFF;
    box-shadow: 0px 18px 23px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    padding-top: 40px;
    padding-bottom: 20px;

    div.modal-container-wrap {
        width: 325px;

        @media screen and (max-width: 767px) {
            width: 73%
        }

        button {
            width: 100%;
            height: 48px;
            &.inactive {
                background: #F4F4F4 !important;
                color: #858585 !important;
                transition: all 0.2s ease;
                &:hover {
                    box-shadow: 0px 4px 8px #858585;
                }
            }
        }
    }

}
.md-field {
    width: 100%;
    min-height: 48px;
    margin: 0px 0 22px;
    padding-top: 8px;
    display: flex;
    position: relative;
    font-family: inherit;

    &.name-required {
        label {
            color: #fa5c7cb3 !important;
        }
        input {
            border: 1px solid #fa5c7cb3 !important;
        }
    }
    div.name-required {
        position: absolute;
        top: 100%;
    }

    &.md-theme-default::after,
    &.md-theme-default::before {
        background-color: transparent;
        content: none !important;
    }

    &.md-focused label,
    &.md-has-value label {
        pointer-events: auto;
        top: 5px;
        opacity: 1;
        font-size: 12px;
        background: #fff;
    }

    .md-input {
        height: 48px !important;
        border: 1px solid #C7C4C4 !important;
        box-sizing: border-box;
        border-radius: 5px;
        padding-left: 10px !important;
    }

    label {
        position: absolute;
        top: 50%;
        left: 11px;
        pointer-events: none;
        transform: translateY(-35%);
        transition: .4s cubic-bezier(.25, .8, .25, 1);
        transition-duration: .3s;
        font-size: 13px;
        line-height: 20px;
        margin: 0;
    }
}
@media (max-width: 991px) {
    div.sign-up {
        width: 100%;
    }
}
</style>